import { FlowStepEditor } from "../FlowStepEditor";
import React from "react";
import { RunRuleTable } from "../../../rule-engine-core/Flow/Steps/Rules/RunRuleTable";
// import { StyledButton } from "../../../CommonUI/Components/Button";
// import { Layer } from "../../../CommonUI/Components/Layer";
// import { RuleTableBuilder } from "../../../Rule/Table/RuleTable/RuleTableBuilder";
// import { StateManager } from "../../../Common/Common/StateManager";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StepEditUI = ({ step }: { step: RunRuleTable }) => {
    //    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <></>

        // <>
        //         <StyledButton sx={{color:UIStyleConstants.BLUE_COLOR}} variant="contained" onClick={() => setOpen(true)}>
        //             Edit {step.name || "Rule Step"}
        //         </StyledButton>
        //
        //         <UILayer
        //             open={open}
        //             maxWidth={false}
        //             fullScreen
        //             padding="0px 0px"
        //             renderUI={() => (
        //                 <RuleTableBuilder
        //                     ruleDefinition={step.executable}
        //                     title={step.executable.title || step.name}
        //                     onRuleCancel={() => {
        //                         setOpen(false);
        //                     }}
        //                     onRuleSave={() => {
        //                         StateManager.changed(step);
        //                         setOpen(false);
        //                     }}
        //                 />
        //             )}
        //             onClose={() => setOpen(false)}
        //         />
        //     </>
    );
};

export class RunRuleTableEditor extends FlowStepEditor<RunRuleTable> {
    renderEditUI(): JSX.Element | null {
        return <StepEditUI step={this.stepData} />;
    }
}
